import capitalize from '../../lib/capitalize'

export const weekdays = [
	'Sunday',
	'Monday',
	'Tuesday',
	'Wednesday',
	'Thursday',
	'Friday',
	'Saturday',
]

export function autocomplete(limit = 2) {
	const day = new Date().getDay() + 1

	return [...Array(limit)].map((v, i) =>
		weekdays[((day + i) % 7)]
	)
}

export function predict(string, limit = 1) {
	const words = string.trim().toLowerCase().split(' ')
	const index = weekdays.indexOf(capitalize(words[0]))

	if (index > -1) {
		return [...Array(limit)].map((v, i) =>
			weekdays[(index + i + 1) % 7]
		)
	}

	return []
}



// WEBPACK FOOTER //
// ./src/services/prediction/date.js